import { inject, Injectable } from '@angular/core';
import { AuthService } from "./auth.service";
import { Session } from "./session.service";
import { NgxPendoService } from "ngx-pendo";
import { AppConstants } from "../app-constants";

@Injectable({
  providedIn: 'root'
})
export class PendoService {

  protected ngxPendoService: NgxPendoService = inject(NgxPendoService);
  private authService: AuthService = inject(AuthService);
  private session: Session = inject(Session);
  initializePendoService() {
    //console.log("Initializing Pendo service");
    if( this.authService.isAuthenticated() ) {
      const user = this.session.getUser();
      let organizationType = "Institution";
      if( this.session.isAccreditor() ) {
        organizationType = "Accreditor";
      } else if( this.session.isFederation() ) {
        organizationType = "Federation";
      }
      if( user ) {
        const accreditorOnlineList = user.userData.accreditorList && Array.isArray( user.userData.accreditorList ) ? user.userData.accreditorList.filter( accreditor => accreditor.isAccreditorOnline ).map( accreditor => accreditor.abbreviation ) : [];
        const accreditorInstitutionDirectoryNames = Array.isArray( this.session.getInstitutionDirectoryProfiles() ) ? this.session.getInstitutionDirectoryProfiles().map( profile => profile.accreditorName ) : [];
        const accreditorProgramDirectoryNames = Array.isArray( this.session.getProgramInstitutionDirectoryProfiles() ) ? this.session.getProgramInstitutionDirectoryProfiles().map( profile => profile.accreditorName ) : [];
        // filter accreditorInstitutionDirectoryNames for duplicates
        const accreditorInstitutionDirectoryNamesSet = new Set( accreditorInstitutionDirectoryNames );
        // filter accreditorProgramDirectoryNames for duplicates
        const accreditorProgramDirectoryNamesSet = new Set( accreditorProgramDirectoryNames );
        const accreditorDirectoryNames = [ ...accreditorInstitutionDirectoryNamesSet, ...accreditorProgramDirectoryNamesSet ].join( ", " );
        const membershipType = this.session.getAccountStatus()?.subscription.name;

        const visitor = {
          id: user.userId.toString(),   // Required if user is logged in
          email: user.userData.email,
          isAdmin: user.userRoles.isOrgAdmin,
          firstName: user.userData.firstName,
          lastName: user.userData.lastName,
          active: "true",
          lastLogin: user.userData.lastLogin === "0001-01-01T00:00:00" ? null : new Date( user.userData.lastLogin ).toLocaleDateString( "en-US" ),
          isAccreditorDirectoryLiaison: user.userData.isAccreditorDirectoryLiaison + "", //convert boolean to string
          role: this.session.getCurrentUserRole(),
          //legacy
          username: user.username,
          institution: user.userOrganizationData.name,
          isAccreditor: this.session.isAccreditor() + "",
          isFederation: this.session.isFederation() + "",
          isVerifyFacilitator: user.userRoles.isVerifyFacilitator + "",
          isVerifyManager: user.userRoles.isVerifyManager + "",
          isProgramLeader: user.userData.isProgramLeader + "",
          accreditorOnlineList: accreditorOnlineList,
        };
        const account = {
          id: this.session.getCurrentAccountRequestKey(), // Highly recommended
          name: this.session.getCurrentAccountName(),
          accountName: this.session.getCurrentAccount().accountName,
          oldName: user.userOrganizationData.name,
          authenticationMethod: this.getAuthenticationNameByGuid( user.userOrganizationData.authenticationMethodGuid ),
          accreditationProjectName: this.session.getCurrentAccount().accredProjectName,
          hasEvent: this.session.getCurrentAccount().hasEvent + "",
          isAccreditorDirectoryInstitution: user.userData.isAccreditorDirectoryInstitution + "",
          accreditorDirectoryNames: accreditorDirectoryNames,
          accreditorName: this.session.getCurrentAccount().accreditorName,
          accreditorAbbr: this.session.getCurrentAccount().accreditorAbbr,
          isAccreditor: this.session.isAccreditor() + "",
          isFederation: this.session.isFederation() + "",
          organizationType: organizationType,
          active: "true",
          applicationDate: user.userOrganizationData.dateAdded,
          membershipType: membershipType,
          //legacy
          accreditorOnlineList: accreditorOnlineList,
          workspaces: "Accreditation"
          //workspaces: workspaces.join( ", " ),
          // You can add any additional account level key-values here,
          // as long as it's not one of the above reserved names.
        }

        /*if( this.session.isImpersonatedUser() ) {
          console.log( "Pendo data initialized" )
          console.log( "Impersonated User: ", user );
          console.log( "Visitor: ", visitor );
          console.log( "Account: ", account );
        }*/

        this.ngxPendoService.initialize( visitor, account );
      }
    }
  }
  getAuthenticationNameByGuid(guid){
    const authNameKey = Object.keys(AppConstants.authenticationMethod).filter(key => AppConstants.authenticationMethod[key].guid === guid);
    if(authNameKey.length) return AppConstants.authenticationMethod[authNameKey[0]].name;
    return String();
  }
}
